if (!window.__productCardInitialized) {
  window.__productCardInitialized = true;

  var desktopMQ = window.matchMedia('(min-width: 750px)');

  /* ---- Swatch click ---- */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product-card-container .swatch-dot');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.product-card-container');
    if (!card) return;

    /* Update active state */
    card.querySelectorAll('.swatch-dot').forEach(function (s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    /* Update images */
    var primaryImg = card.querySelector('.primary-image');
    var secondaryImg = card.querySelector('.secondary-image');

    if (primaryImg && swatch.dataset.primaryImage) {
      primaryImg.src = swatch.dataset.primaryImage;
      primaryImg.removeAttribute('srcset');
    }
    if (secondaryImg && swatch.dataset.secondaryImage) {
      secondaryImg.src = swatch.dataset.secondaryImage;
      secondaryImg.removeAttribute('srcset');
    }

    /* Store current images for hover restore */
    card.dataset.currentPrimarySrc = swatch.dataset.primaryImage || '';
    card.dataset.currentSecondarySrc = swatch.dataset.secondaryImage || '';

    /* Update title */
    var titleEl = card.querySelector('[data-field="title"]');
    if (titleEl) titleEl.textContent = swatch.dataset.productTitle;

    /* Update price */
    var priceEl = card.querySelector('[data-field="price"]');
    if (priceEl) {
      var compareAt = swatch.dataset.compareAtPrice;
      var price = swatch.dataset.productPrice;
      if (compareAt) {
        priceEl.innerHTML = '<s class="compare-price">' + compareAt + '</s> <span class="current-price sale-price">' + price + '</span>';
      } else {
        priceEl.innerHTML = '<span class="current-price">' + price + '</span>';
      }
    }

    /* Update material */
    var materialEl = card.querySelector('[data-field="material"]');
    if (materialEl) {
      var mat = swatch.dataset.material;
      if (mat) {
        materialEl.textContent = mat;
        materialEl.style.display = '';
      } else {
        materialEl.style.display = 'none';
      }
    }

    /* Update all card links */
    card.querySelectorAll('[data-card-link]').forEach(function (link) {
      link.href = swatch.dataset.productUrl;
    });

    /* Update quick-add data */
    card.dataset.productHandle = swatch.dataset.productHandle || '';
    card.dataset.singleVariant = swatch.dataset.singleVariant || 'false';
    card.dataset.firstVariantId = swatch.dataset.firstVariantId || '';
    var quickAddBtn = card.querySelector('.quick-add-btn');
    if (quickAddBtn) quickAddBtn.dataset.productId = swatch.dataset.productId;
  });

  /* ---- Swatch hover (desktop only) ----
     Uses mouseover/mouseout (which bubble) instead of mouseenter/mouseleave
     so delegation on document works without capture phase. */
  document.addEventListener('mouseover', function (e) {
    if (!desktopMQ.matches || e.target.nodeType !== 1) return;
    var swatch = e.target.closest('.product-card-container .swatch-dot');
    if (!swatch) return;

    /* Skip events caused by moving between the swatch's own children */
    if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;

    var card = swatch.closest('.product-card-container');
    if (!card) return;

    var primaryImg = card.querySelector('.primary-image');
    if (!primaryImg) return;

    if (!card.dataset.hoverOriginalSrc) {
      card.dataset.hoverOriginalSrc = primaryImg.src;
    }

    if (swatch.dataset.primaryImage) {
      primaryImg.src = swatch.dataset.primaryImage;
      primaryImg.removeAttribute('srcset');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!desktopMQ.matches || e.target.nodeType !== 1) return;
    var swatch = e.target.closest('.product-card-container .swatch-dot');
    if (!swatch) return;

    /* Skip events caused by moving between the swatch's own children */
    if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;

    var card = swatch.closest('.product-card-container');
    if (!card) return;

    var primaryImg = card.querySelector('.primary-image');
    if (!primaryImg || !card.dataset.hoverOriginalSrc) return;

    var activeSrc = card.dataset.currentPrimarySrc || card.dataset.hoverOriginalSrc;
    primaryImg.src = activeSrc;
    delete card.dataset.hoverOriginalSrc;
  });

  /* ---- Quick-add click ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card-container .quick-add-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.product-card-container');
    document.dispatchEvent(new CustomEvent('product-card:quick-add', {
      detail: {
        productId: btn.dataset.productId,
        productHandle: card ? card.dataset.productHandle : '',
        productUrl: card ? card.querySelector('[data-card-link]').href : '',
        singleVariant: card ? card.dataset.singleVariant === 'true' : false,
        variantId: card ? card.dataset.firstVariantId : ''
      }
    }));
  });

  /* ---- Mobile scroll indicator ---- */
  function initScrollIndicators() {
    if (desktopMQ.matches) return;

    document.querySelectorAll('.product-card-container .image-scroll').forEach(function (scroll) {
      var images = scroll.querySelectorAll('.card-image');
      var card = scroll.closest('.product-card-container');
      if (!card || images.length < 2) return;

      var dots = card.querySelectorAll('.dot');
      if (dots.length < 2) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = Array.from(images).indexOf(entry.target);
            dots.forEach(function (d, i) {
              d.classList.toggle('active', i === index);
            });
          }
        });
      }, {
        root: scroll,
        threshold: 0.5
      });

      images.forEach(function (img) {
        observer.observe(img);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollIndicators);
  } else {
    initScrollIndicators();
  }
}
